export default import.meta.ROLLUP_FILE_URL_2TCw4ZPx;